import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { History } from "lucide-react";

export default function Changelog() {
  const { data = [] } = useQuery({
    queryKey: ["changelog"],
    queryFn: async () => (await api.get("/platform/changelog")).data,
  });

  return (
    <div className="p-8 max-w-4xl" data-testid="changelog-page">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-9 h-9 rounded-md border border-zinc-200 grid place-items-center bg-white">
          <History className="w-4 h-4 text-zinc-700" />
        </div>
        <div>
          <h1 className="font-heading text-2xl font-extrabold tracking-tight">Deployment Changelog</h1>
          <p className="text-sm text-zinc-500 mt-0.5">Every production release, in reverse chronological order.</p>
        </div>
      </div>

      <ol className="border-l border-zinc-200 pl-6 space-y-8">
        {data.map((rel) => (
          <li key={rel.version} className="relative" data-testid={`release-${rel.version.split(" ")[0].toLowerCase()}`}>
            <span className="absolute -left-[29px] top-1.5 w-2.5 h-2.5 rounded-full bg-zinc-900" />
            <div className="font-heading text-base font-bold">{rel.version}</div>
            <ul className="mt-2 space-y-1 text-sm text-zinc-700">
              {rel.notes.map((n, i) => (
                <li key={`${rel.version}-${i}`} className="flex items-start gap-2">
                  <span className="w-1 h-1 rounded-full bg-zinc-400 mt-2 shrink-0" />
                  <span>{n}</span>
                </li>
              ))}
            </ul>
          </li>
        ))}
        {data.length === 0 && (
          <li className="text-sm text-zinc-500 -ml-6">No releases logged yet.</li>
        )}
      </ol>
    </div>
  );
}
